import * as R from 'ramda';
import { httpGet } from 'apiModule/rest';
import adapter from 'dataModule/adapter';
import { getQueriesString, getQueriesObject } from 'utilsModule';
import { attachPaginationQueryInfo } from 'dataModule/dataManager/utils';

const retrieveWarehouseList = async () =>
  R.pipe(
    () => httpGet('warehouse/list'),
    response => response.then(adapter.inventory.retrieveWarehouseList.be2fe),
  )();

const retrieveWarehouseStockList = async ({ params: { queries } }) =>
  R.pipe(
    getQueriesString,
    queriesString => httpGet(`warehouseStock/list${queriesString}`),
    response => response.then(adapter.inventory.retrieveWarehouseStockList.be2fe),
  )(queries);

const retrieveAvailableDevices = async ({ params: { queries = [] } = {} }) =>
  R.pipe(
    getQueriesString,
    queriesString => httpGet(`device/available${queriesString}`),
    response => response.then(adapter.inventory.retrieveAvailableDevices.be2fe),
  )(queries);

const retrieveAvailableConsumables = async ({ params: { queries = [] } = {} }) =>
  R.pipe(
    getQueriesString,
    queriesString => httpGet(`consumable/warehouses/available${queriesString}`),
    response => response.then(R.pipe(
      adapter.inventory.retrieveAvailableConsumables.be2fe,
      attachPaginationQueryInfo(getQueriesObject(queries)),
    )),
  )(queries);

const DM = {
  retrieveWarehouseList,
  retrieveWarehouseStockList,
  retrieveAvailableDevices,
  retrieveAvailableConsumables,
};

const ajax = async ({ method, input = {} }) => ({
  [method]: await DM[method](input),
});

export default { ...DM, ajax };
